export default __webpack_public_path__ + "static/media/icon-key-hand.3bba2e1e.svg";